import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['subdomain'];

  ///////////////
  /// Actions ///
  ///////////////

  goToSubdomain() {
    if (!this.hasSubdomainTarget) return;

    const domain = (this.subdomainTarget.value || '').trim().toLowerCase();
    if (domain === '') return;

    window.location = `${window.location.href}/${domain}`;
  }
}
